var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.orderProducts.length
    ? _c(
        "div",
        {
          staticClass:
            "battery-order-view__container battery-order-view__container--order"
        },
        [
          _c("ProductHeader"),
          _vm._v(" "),
          _vm._l(_vm.orderProducts, function(product, index) {
            return _c("Product", {
              key: index,
              attrs: { index: index, product: product }
            })
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "css-grid battery-order-view__row battery-order-view__row--total"
            },
            [
              _c("div"),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _c("div", { staticClass: "h-right-align" }, [_vm._v("Total:")]),
              _vm._v(" "),
              _c("div", { staticClass: "h-center-align" }, [
                _vm._v(_vm._s(_vm.formattedOrderTotal))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "h-center-align" }, [
                _vm._v(_vm._s(_vm.totalBatteries) + " batteries")
              ])
            ]
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }